import {
  Box,
  useMediaQuery,
  useTheme
} from "@mui/material";
import React from "react";

interface MainProps {
  children: React.ReactNode;
}

export const Main: React.FC<MainProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: "100%",
          height: "100vh",
          overflow: "auto",
          ...(isMobile && {
            mt: 4,
          }),
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
